// Générateur d'alarmes audio WebAudio → Blob URL (aucun fichier statique nécessaire).
// Presets restaurateur : bip strident, grelot/cloche, mélodie douce.
// Preset chauffeur supplémentaire : klaxon (impossible à rater en ville).
export const SOUND_LABELS = { bip: "Bip", grelot: "Grelot", melodie: "Mélodie", klaxon: "Klaxon" };

const SR = 44100;
const DUR = 2.2;

function _writeWav(buf) {
  const N = buf.length;
  const ab = new ArrayBuffer(44 + N * 2);
  const dv = new DataView(ab);
  const wr = (o, s) => { for (let i = 0; i < s.length; i++) dv.setUint8(o + i, s.charCodeAt(i)); };
  wr(0, "RIFF"); dv.setUint32(4, 36 + N * 2, true);
  wr(8, "WAVEfmt "); dv.setUint32(16, 16, true); dv.setUint16(20, 1, true);
  dv.setUint16(22, 1, true); dv.setUint32(24, SR, true);
  dv.setUint32(28, SR * 2, true); dv.setUint16(32, 2, true); dv.setUint16(34, 16, true);
  wr(36, "data"); dv.setUint32(40, N * 2, true);
  for (let i = 0; i < N; i++) dv.setInt16(44 + i * 2, Math.max(-1, Math.min(1, buf[i])) * 32767, true);
  return URL.createObjectURL(new Blob([ab], { type: "audio/wav" }));
}


function _synthesize(kind) {
  const N = Math.floor(SR * DUR);
  const b = new Float32Array(N);
  const twoPI = 2 * Math.PI;
  for (let i = 0; i < N; i++) {
    const t = i / SR;
    let s = 0;
    if (kind === "bip") {
      // Double sinus 880 + 1320 Hz, enveloppe carrée (200ms on / 150ms off)
      const env = ((t % 0.35) < 0.20) ? 0.9 : 0;
      s = env * (Math.sin(twoPI * 880 * t) * 0.55 + Math.sin(twoPI * 1320 * t) * 0.45);
    } else if (kind === "grelot") {
      // Grelot / clochette : accord métallique 1200/2400/3600 Hz avec enveloppe percussive répétée
      const period = 0.55;
      const phase = t % period;
      const env = Math.max(0, 1 - phase / 0.35) ** 3; // attack instantanée, decay ~0.35s
      s = env * (
        Math.sin(twoPI * 1200 * t) * 0.4 +
        Math.sin(twoPI * 2400 * t) * 0.35 +
        Math.sin(twoPI * 3600 * t) * 0.2 +
        Math.sin(twoPI * 5200 * t) * 0.1
      );
    } else if (kind === "melodie") {
      // Do — Mi — Sol (arpège doux) 3 notes de 0.55s, sinus pur avec enveloppe ADSR douce
      const notes = [523.25, 659.25, 783.99];
      const idx = Math.floor(t / 0.55) % notes.length;
      const local = (t % 0.55);
      const attack = Math.min(1, local / 0.08);
      const decay = Math.max(0.35, 1 - local / 0.55);
      const env = attack * decay;
      s = env * Math.sin(twoPI * notes[idx] * t) * 0.55;
    } else if (kind === "klaxon") {
      // Klaxon voiture : sinus 440 + 550 Hz (quinte), enveloppe 0.6s ON / 0.3s OFF
      const period = 0.9;
      const phase = t % period;
      const on = phase < 0.6 ? 1 : 0;
      // légère modulation d'amplitude pour un effet mécanique plus réaliste
      const wobble = 1 + 0.15 * Math.sin(twoPI * 6 * t);
      s = on * wobble * 0.7 * (
        Math.sin(twoPI * 440 * t) * 0.55 +
        Math.sin(twoPI * 550 * t) * 0.45
      );
    }
    b[i] = s;
  }
  return _writeWav(b);
}


export function makeAlarmBlobUrl(kind = "bip") {
  if (!["bip", "grelot", "melodie", "klaxon"].includes(kind)) kind = "bip";
  return _synthesize(kind);
}
